export const APPOINTMENT_ORDER_OPTION_GROUPS = [
  {
    id: 'device',
    labelKey: 'reports.healthHouseChecksList',
    options: [
      { value: 'blood_pressure', labelKey: 'checkTypes.blood_pressure' },
      { value: 'blood_glucose', labelKey: 'checkTypes.blood_glucose' },
      { value: 'hemoglobin', labelKey: 'checkTypes.hemoglobin' },
      { value: 'temperature', labelKey: 'checkTypes.temperature' },
      { value: 'body_height_weight', labelKey: 'checkTypes.body_height_weight' },
      { value: 'spo2', labelKey: 'checkTypes.spo2' },
      { value: 'lipid_panel', labelKey: 'checkTypes.lipid_panel' },
      { value: 'body_composition', labelKey: 'checkTypes.body_composition' },
      { value: 'uric_acid', labelKey: 'checkTypes.uric_acid' },
      { value: 'cholesterol', labelKey: 'checkTypes.cholesterol' },
      { value: 'urine_glucose', labelKey: 'checkTypes.urine_glucose' }
    ]
  },
  {
    id: 'lab-imaging',
    labelKeys: ['checkTypes.lab', 'checkTypes.scan'],
    options: [
      { value: 'blood', labelKey: 'checkTypes.blood' },
      { value: 'urine', labelKey: 'checkTypes.urine' },
      { value: 'ecg', labelKey: 'checkTypes.ecg' },
      { value: 'ct', labelKey: 'checkTypes.ct' },
      { value: 'xray', labelKey: 'checkTypes.xray' },
      { value: 'ultrasound', labelKey: 'checkTypes.ultrasound' },
      { value: 'mri', labelKey: 'checkTypes.mri' },
      { value: 'pathology', labelKey: 'checkTypes.pathology' },
      { value: 'endoscopy', labelKey: 'checkTypes.endoscopy' },
      { value: 'other', labelKey: 'checkTypes.other' }
    ]
  }
];

const humanizeType = (type) => type
  .split('_')
  .filter(Boolean)
  .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
  .join(' ');

export const getAppointmentOrderGroupLabel = (group, t) => {
  if (group.labelKey) {
    return t(group.labelKey);
  }
  return (group.labelKeys || []).map((key) => t(key)).join(' / ');
};

export const getAppointmentOrderTypeLabel = (type, t) => {
  const normalizedType = String(type || '').trim();
  if (!normalizedType) {
    return t('common.unknown');
  }

  const translated = t(`checkTypes.${normalizedType}`, { defaultValue: '' });
  return translated || humanizeType(normalizedType);
};
